export default "/images/0d9fb107e2504ca53f22f280872506fc.avif";